// extracted by mini-css-extract-plugin
export default {"root":"PLtEj__root","container":"MpxGg__container","slider":"gCmZG__slider","smallSizePlayer":"Pz7Nk__smallSizePlayer"};